"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
class LogProvider extends DataProvider_1.default {
    log(_a) {
        var _b = _a.data, { body = {} } = _b, others = tslib_1.__rest(_b, ["body"]);
        return this.mutate("log", { data: Object.assign({ body: JSON.stringify(body) }, others) });
    }
}
exports.LogProvider = LogProvider;
//# sourceMappingURL=LogProvider.js.map